module.exports = __webpack_public_path__ + "static/media/Rain 4.c9513b47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Rain 4.jpg
// module id = 137
// module chunks = 0